import { render, staticRenderFns } from "./CustomizeMetalW.vue?vue&type=template&id=7cd12f95&scoped=true"
import script from "./CustomizeMetalW.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalW.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalW.vue?vue&type=style&index=0&id=7cd12f95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd12f95",
  null
  
)

export default component.exports